import { IM360Parser } from '../../IM360Parser'

export function parseLastResort({
  title,
  statement,
  studentResponse,
}: {
  title?: string
  statement?: string
  studentResponse?: string
}) {
  if (!statement && studentResponse?.trim()) {
    return [
      IM360Parser.getInstance().createNoteNode({
        title: 'Student Response',
        value: studentResponse,
        studentFacing: false,
      }),
    ]
  }
  if (!statement) {
    return
  }

  return [
    IM360Parser.getInstance().createShortAnswer({
      title,
      description: statement,
      teacherNote: studentResponse,
    }),
  ]
}
